import {mergeTo} from '#core/utils/config-utils.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {SportsContent} from '../sports-content.js';

import {couponsFactory} from './coupons.factory';

import PALETTE_SCHEMA from './coupons.palette-schema.yaml';
import SCHEMA from './coupons.schema.yaml';

class CouponsFeature extends AbstractVisualFeature {
    get name() {
        return 'Coupons';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    get configSchema() {
        return SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return mergeTo(couponsFactory(PALETTE), {
            MatchesCoupon: {
                eventsCoupon: {
                    initialExpandedGroups: this.config.eventsCouponInitialExpandedGroupsAmount,
                },
            },
            CmsSportCouponView: {
                eventCoupon: {
                    initialExpandedGroups: this.config.cmsSportCouponInitialExpandedGroupsAmount,
                },
            },
            SingleLeagueCoupon: {
                eventsCoupon: {
                    initialExpandedGroups: this.config.singleLeagueCouponInitialExpandedGroupsAmount,
                },
            },
            InPlayContent: {
                eventsCouponPerTab: {
                    base: {
                        initialExpandedGroups: this.config.sportTabCouponInitialExpandedGroupsAmount,
                    },
                    all: {
                        initialExpandedGroups: this.config.allTabCouponInitialExpandedGroupsAmount,
                    },
                },
            },
        });
    }
}

export const Coupons = new CouponsFeature(SportsContent);
